module.exports = __webpack_public_path__ + "img/coreset2.ea31858a.svg";